import { render, staticRenderFns } from "./dispatch.vue?vue&type=template&id=7ae0e9bb&scoped=true"
import script from "./dispatch.vue?vue&type=script&lang=js"
export * from "./dispatch.vue?vue&type=script&lang=js"
import style0 from "./dispatch.vue?vue&type=style&index=0&id=7ae0e9bb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae0e9bb",
  null
  
)

export default component.exports